import { SxProps, Theme } from '@mui/material/styles';
import { bloxValues } from 'themes/constants';

/**
 * Compact Checkbox/Radio styles
 * for visual display only
 */
export function getCheckRadioSx(theme: Theme): SxProps<Theme> {
  return {
    padding: 0,
    margin: 0,
    fontSize: bloxValues.iconSizeSmall,
    '& svg': {
      fontSize: bloxValues.iconSizeSmall,
    },
  };
}

/**
 * Compact IconButton parent styles
 * styles for input end icons
 */
export function getIconButtonSx(theme: Theme): SxProps<Theme> {
  return {
    fontSize: bloxValues.iconSizeRegular,
    color: theme.palette.text.secondary,
    p: 0,
  };
}
